import { Component, forwardRef } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { AccountViewComponent } from './account-view.component';

export namespace NAccountViewCms {
    export const BLOCK_ID = 'cms-account-view';

    export type IBlockData = Catalog.IBlockData<IBlockDataContent>;

    export interface IBlockDataContent {
        /**
         * Bottom components list
         */
        bottomComponents: NICmsContentComponent.IData[];
        buttonUrl?: string;
    }
}

/**
 * Component definition
 */
@Component({
    selector: 'cms-account-view',
    template: '@if (content) {<account-view [content]="content"></account-view>}',
    standalone: true,
    imports: [forwardRef(() => AccountViewComponent)]
})
@ICmsComponent<AccountViewCmsComponent>({
    id: NAccountViewCms.BLOCK_ID,
    block: {
        url: NAccountViewCms.BLOCK_ID
    },
    onDemandOnly: true,
    name: 'Account pages layout',
    description: 'Account pages layout block',
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'bottom-section',
            title: 'Bottom contents'
        },
        <NICmsContentField.IComponentsField>{
            key: 'bottomComponents',
            type: NICmsContentField.EFieldType.components,
            title: 'Bottom components',
            itemName: 'component',
            default: []
        },
        {
            key: 'buttonUrl',
            type: NICmsContentField.EFieldType.text,
            title: 'Button Url',
            default: 'https://manage.kmail-lists.com/subscriptions/unsubscribe?a=W8Qthw&g=WiGe2E&m=UtW3Ry'
        }
    ]
})
export class AccountViewCmsComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NAccountViewCms.IBlockDataContent;

    protected override canDetach = false;
}
